import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #fff;
    padding: 30px 60px;
    margin: 0 15px;
    width: 100%;
    color: #0b2f3f;

    .center {
        text-align: center;
    }

    .logo {
        max-width: 280px;
        width: 100%;
    }

    .simulator {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 2em;
        max-width: 800px;
        margin: 0 auto;

        label {
            display: block;
            margin-bottom: 5px;
        }

        input, select {
            border: 1px solid #cfdadd;
            height: 40px;
            font-size: 15px;
            padding: 12px 40px 12px 12px;
            background-color: #fff;
            border-radius: 2px;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
            transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
            width: 100%;

            &:disabled {
                background-color: #f6f8fb;
            }
        }
        
        p {
            margin: 10px 0;
        }

        .price {
            position: relative;

            :after {
                content: "CFP";
                display: block;
                position: absolute;
                top: 35px;
                right: 10px;
                color: #9d9d9d;
            }
        }
    }

    .error {
        input {
            border-color: red;
        }

        span {
            font-size: 12px;
            color: red;
        }
    }

    .legals {
        max-width: 600px;
        margin: 0 auto;
    }

    @media screen and (max-width: 47.9em) {
        padding: 30px;
    }
`;
